function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from "react";
import baseOC from "icfrontendbase";
import { useSharedStorage, usePopover } from "../../../../index";
import { FileIcon, PositionedPopover, TriggeredPopover, ClickAwayPopoverWrapper, TextButton } from "../../../../styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import "./compDetailReport.css";
const CompDetailReportPdf = ({
  complianceCode
}) => {
  const [cloudAccountId] = useSharedStorage("cac_in_focus_cloud_account_id");
  const [assessmentExceptionType] = useSharedStorage("assessment_exception_type");
  const [triggerProps, popoverProps, closePopover] = usePopover();

  // determine the exception type to send to the bizapi
  const exceptionTypeParamValue = useMemo(() => {
    const exceptionTypeMap = {
      as_of_assessment: "with_exception_as_of_assessment",
      contemporary: "with_exception_as_of_request"
    };
    const result = exceptionTypeMap[assessmentExceptionType];
    if (result) {
      return result;
    }
    const logger = baseOC.get("Logger");
    logger.warn(`No exception type found for assessment_exception_type: ${assessmentExceptionType}. Defaulting to contemporary`);
    return exceptionTypeMap.contemporary;
  }, [assessmentExceptionType]);
  const ianaTimezone = useMemo(() => {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!timezone) throw new Error();
      return timezone;
    } catch (error) {
      console.warn("Unable to get the client timezone. Using default instead");
      return "UTC";
    }
  }, []);
  const domain = useMemo(() => {
    return window.location.hostname.split(".").slice(1).join('.') || "icompaas.com";
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "comp-detail-report"
  }, /*#__PURE__*/React.createElement(ClickAwayPopoverWrapper, {
    onClickAway: closePopover
  }, /*#__PURE__*/React.createElement(PositionedPopover, {
    position: "bottom"
  }, /*#__PURE__*/React.createElement(TriggeredPopover, _extends({
    trigger: /*#__PURE__*/React.createElement(FileIcon, _extends({
      type: "pdf"
    }, triggerProps))
  }, popoverProps), /*#__PURE__*/React.createElement("div", {
    className: "comp-detail-report-popover-content"
  }, /*#__PURE__*/React.createElement("a", {
    href: `/business/proxy/product/cloud/assessment/latest/pdf_report` + `?cloud_id=${cloudAccountId}` + `&compliance_code=${complianceCode}` + `&exception_type=${exceptionTypeParamValue}` + `&tz=${ianaTimezone}` + `&domain=${domain}`,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(TextButton, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "comp-detail-report-popover-content-icon",
    icon: faArrowUpRightFromSquare
  }), "Control Report (.pdf)")))))));
};
export { CompDetailReportPdf };